import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const PricingFAQ = () => {
  const faqs = [
    {
      question: 'Can we upgrade or downgrade anytime?',
      answer: 'Absolutely. Camps grow — and CampChef Pro grows with you. You can change plans at any time, and we\'ll adjust your billing at the next cycle. No hassle, no penalties.',
    },
    {
      question: 'Do you offer onboarding help?',
      answer: 'Yes, every plan includes guided setup to help you import menus, recipes, and staff accounts. We\'ll make sure your team is confident before your first session starts.',
    },
    {
      question: 'Can volunteers use the system?',
      answer: 'Of course! CampChef Pro was designed to be simple enough for volunteers and seasonal staff. Your kitchen coordinator sets things up, and everyone else can jump in with minimal training.',
    },
    {
      question: 'Does it work offline?',
      answer: 'You can still view saved menus, recipes, and generate reports even when Wi-Fi drops at camp. Data syncs automatically once you\'re back online.',
    },
    {
      question: 'How does the 14-day free trial work?',
      answer: 'You get full access to your selected plan with no credit card required. If you decide to continue after 14 days, we\'ll process your first payment and help you get fully set up.',
    },
    {
      question: 'What if we need to cancel?',
      answer: 'You can cancel anytime with no cancellation fees. You\'ll retain access through the end of your billing period, and we\'re always happy to help if you decide to come back.',
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">Questions About Pricing?</h2>
          <p className="text-lg text-muted-foreground">
            We're here to help you choose the right plan for your camp
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border border-border rounded-lg px-6 bg-card hover:border-copper/30 transition-colors"
            >
              <AccordionTrigger className="text-left hover:text-copper transition-colors">
                <span className="font-semibold text-foreground">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
